module.exports = __webpack_public_path__ + "static/media/icon_kitchen.2b5e2ea4.svg";